import loadable from '@loadable/component';

// 懒加载组件
const LicenseManagement = loadable(() => import('./licenseManagement/LicenseManagement'));
const ProductLicenseManagement = loadable(() => import('./productLicenseManagement/ProductLicenseManagement'));

export default [
  {
    path: '/LicenseManagement',
    component: LicenseManagement
  },
  {
    path: '/ProductLicenseManagement',
    component: ProductLicenseManagement
  }
];
